import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import JisPrepareTemplate from '../../components/core/preparetemplate';
import PdfViewer from '../../components/controls/pdfviewer';
import { s } from 'framer-motion/client';
import JisTabButton from '../../components/controls/jisTabButton';
import JisAlert from '../../components/jisalert';
import DeadlineBadge from '../../components/controls/deadlinebadge';

function ServiceSherrifSubstitutted() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);
    const [isLiti, setIsLitiation]=useState(null);
    const [openOption, setOpenOption] = useState(false);
    const [comment, setComment] =useState('');
    const [option, setOption]=useState({});
    const [suitNumber, setSuitnumber]=useState('');
    const [selected, setSelected] = useState(new Set()); //to hold the selected 
    const [isAddService, setIsAddService] =useState(false);

    const [selectedParty, setSelectedParty] =useState(null);
    const [selectedService, setSelectedService] = useState('substituted'); //true/false
    const [caseParties, setCaseParties] = useState([]);
    const [template, setTemplate] = useState(null); 
    const [service, setService]=useState(null);
    const [doc, setDoc] =useState(null)
    const [docline, setDocline] = useState(null);
    const [uplinetype, setUplinetype] = useState('attest');
    const [servedon, setServedOn] = useState(null);
    const [sFile, setSFile] =useState(null);
   
    const [previewPath, setPreviewPath] = useState(false);  
    const [services, setServices] = useState([]);
    const [showAll, setShowAll] = useState(false); 
    const [claimants, setClaimants] = useState('');
    const [defendants, setDefendants] = useState('');
    const [autoFill, setAutoFill] = useState([]); //this is to hold the auto fill items
    const [tab, setTab] = useState('substituted');
    const [otherAlert, setOtherAlert]=useState({open:false})
    useEffect(() => {
      if(search!=null){
         if(pageIndex>=0){
           onSearch(search);
         }else{
            setPageIndex(0);
          }
       
      }
          
    }, [pageIndex,pageSize,tab]);


       useEffect(() => {
      
        if(isAddService && active!=null){
          //load the parties to the case
          onLoadParties(active.caseId);
          onLoadServices(active.caseId);
          setSelectedService('');
        }            
    }, [active,isAddService]);

    const IsDefendant=(ptid)=>{
        const v = Constants.getItemById(frequentData.partyTypes,ptid).isLead;
        var m=v??false
        return !m;
    }

    const serviceDetails=(p)=>{
    
      var f= services?.filter((e)=> e.partyId==p.id);
      if(f?.length>0){
        return Constants.formatDate(f[0].servedOn) ;
      }else{
        return 'N/A';
      }
    }

  useEffect(() => {
    if(active!=null && selectedParty!=null){
      console.log('in here befor template call')
      let fill=[{holder:'[DEFENDANT]',value:`${selectedParty.firstName} ${selectedParty.lastName??''}`},
        {holder:'[CLAIMANTS]',value:claimants},{holder:'[DEFENDANTS]', value:defendants}
      ]
    
      setAutoFill(fill);
        onLoadService(active.caseId,selectedParty?.id)     
           setSFile(null);  
        setIsPreview(false); 
    }         
    }, [selectedParty]);  

    useEffect(() => {
    if(active!=null && selectedParty!=null ){
      if(uplinetype=='template'){
        onLoadTemplate();
      }
    }
               
    }, [selectedService]);

  useEffect(() => {
    if(template!=null && servedon!=null  ){
      onSaveSelect();
    }         
    }, [template,servedon,uplinetype]);  

 const onChooseService=(option)=>{
    if(service?.isCompleted){
      return;
    }
    setSelectedService(option);
 }

  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/service-sheriff/${tab}/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoadParties= async(caseid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/loadparties/${caseid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setCaseParties(data.parties);
              let claim=''; let defe='';
              data.parties.forEach(element => {
                if(IsDefendant(element.partyTypeId)){
                  
                  defe=defe+`${element.firstName} ${element.lastName??''},`
                  console.log(`in defendant loop ${defe}`)
                }else{
                  
                  claim=claim+`${element.firstName} ${element.lastName??''},`
                  console.log(`in claimant loop ${claim}`)
                }
              });
              setDefendants(defe);
              setClaimants(claim);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
        const onLoadServices= async(caseid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/load-services-substituted/${caseid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setServices(data.service);
              
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onLoadTemplate= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/load-special-template/sheriff-${selectedService}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setTemplate(data.temp);
              
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }    
    const onLoadService = async(caseid, partyid)=>{
            //for account registration
        try {
          
            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/loadparty-service-sheriff/${caseid}/${partyid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
              //setCaseParties(data.parties); 
              setService(data.service);
              setDoc(data.docup);
              setDocline(data.line);
              if(data.service!=null){
                setSelectedService('substituted')
              }
              const istemp=data.service.isTemplate??false;
              console.log('changed at this point ***********1')
             // setUplinetype(istemp?'template':'document');
              if(data.service.servedOn!=null){
                setServedOn(data.service.servedOn.split('T')[0]);
                console.log(data.service.servedOn);
                console.log(data.service.servedOn);
              }
              

            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
  }

    const onContinue=(kase,ind)=>{
        //navigate(`/case-details/${caseid}`)
        const division=Constants.getItemById(frequentData?.divisions,kase.divisionId)?.title
        var _kase={...kase, 
          division,
       caseType: kase.caseFilingId==1?'litigation':'adr',type:'document' }
        setActive(_kase);
        console.log(`on continue ${division}`)
        console.log(_kase);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }

    const onCloseService=()=>{
      setActive(null);
      setIndex(-1);
      setIsAddService(false);
      setSelectedParty(null);
      setService(null);
      setDoc(null);
    }
    const onAddService =(kase,ind)=>{
        const division=Constants.getItemById(frequentData?.divisions,kase.divisionId)?.title
        var _kase={...kase, 
          division,
       caseType: kase.caseFilingId==1?'litigation':'adr',type:'document' }
        setActive(_kase);
        console.log(`on continue ${division}`)
        console.log(_kase);
        setIndex(ind);
        setIsAddService(true);
    }

 const onSaveSelect=async()=>{

          if(selectedParty==null){
            return;
          }
             
             var isService=false;
             var serviceTitle='Affidavit of Substitutted Service';
              var select={caseId: active.caseId, partyId:selectedParty.id,divisionId:active.divisionId,
                 selectedOption:selectedService,isService, templateId:template.id, serviceTitle, servedOn:servedon,uplineType:uplinetype};
            
             setErr('');

              
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/save-service-sherif-substituted/select`, {
                method: 'POST',
                body:JSON.stringify(select) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            onLoadService(active.caseId,selectedParty?.id);
          // onLoadServices(active.caseId)
            setLoading(false);

            console.log(data);
            if(data.code==0){
            //update the field
               
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 
const onSelectService=(e)=>{
  setSelectedService(e);
}

 const onInstumentAppended=(e)=>{
    //after saving of instrument, this is what you get
      if(e.code==0){
              //saved already
              
          }
  }
 const handleUploadChange =async (e) => {
 
        const files = e.target.files;
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       setSFile(a);

        console.log(a);
      
    };
const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }
const onUploadFiles2= async(caseid,partyid)=>{
        const uploadurl=`${Constants.apiUrl}/filing/upload-service-sheriff-document/${caseid}/${partyid}`
        var upline={
                id: service.docUploadLineId,
                uplineType: "non-attest",
                base64: sFile.base64,
                base64Ext: sFile.base64Ext,
                templateId:0,
                templatetitle: "",
                filename:sFile.filename,
                docuploadid: service.docUploadId
                }

      //  setFlowError('');

            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(upline),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                    //saved already
                    /* setOpenDialog(true);
                    setUploadCode(data.psastatus);
                    setisAttendedTo(data.isAttendedTo) */
                    setService({...service, isAttendedTo:true});
                    setOtherAlert({open:true, title:'Upload Document', subtitle:'Proof of service uploaded', onOk:onOkUpload})

                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }
const onSaveFile=()=>{

  onUploadFiles2(active.caseId, selectedParty.id);
}  
const onSelectParty=(p)=>{
  const isD= IsDefendant(p.partyTypeId);
  if(!isD){
    return;
  }
  setSelectedParty(p)
}

const onPrepareDone=(e)=>{
  //this is coming from from Prepare Document
  console.log('in service sherrif');
 
  //load the attached parties that are defendant, check total service created for them,
  //  then go ahead and close the window and set the the servicestatus to awaitingcfo
onUpdateStatus();
   /* var defendants=caseParties?.filter((k)=> IsDefendant(k.partyTypeId) ).length;
   if(defendants==services.length || defendants==1){
    
   } */
     console.log(`defendant count ${defendants} while services count ${services.length}`)
}
const onUpdateStatus=async()=>{
           
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/service-sheriff-substituted-update/${active?.caseId}`, {
                method: 'POST',
               // body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
              
              setIsAddService(false);
              setPageIndex(-1);
              setDoc(null);
              setDocline(null);
              
            } else if(data.code==-10){
                setIsExpired(true);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
           
            // onMove();
            }
       } 
const gotoESwearing=async(opt,index) =>{
  
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-service-sheriff-substituted-doc/${opt?.caseId}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                navigate(`/prepare-document/${data.id}/legal`);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        
}

const onOkUpload=()=>{
  setOtherAlert({open:false});
  onPrepareDone({source:'upload'});
}

  return (
    <div>
     
      <CaseSearch onSearch={onSearch} frequentData={frequentData} />

      <div className='tab_body'>
<div className='tab_section'>
            <JisTabButton isActive={tab=='substituted'}  
       title="Pending Cases" 
       isRoleBased={false} onClick={()=> setTab('substituted')}/>
       <JisTabButton isActive={tab=='awaitingcfo-substituted'}  title="Awaiting CFO Commissioning " 
       isRoleBased={false} onClick={()=> setTab('awaitingcfo-substituted')}/>
       <JisTabButton isActive={tab=='processed-substituted'}  title="Processed Cases" 
       isRoleBased={false} onClick={()=> setTab('processed-substituted')}/>
        </div>
        <div className='tab_view'>
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Deputy Sherrif </span><span className='total'>{count}</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
   <th>SLA</th>
      <th>Details</th>
     {tab!='processed' && <th>Action</th>} 
     
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => {
      const cc=Constants.getSlaTimeLeft(opt.slaExpire);
      return (
      <tr key={index}>
            <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>{opt.caseNumber}</td>
      <td >{opt.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
      <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
      <td><DeadlineBadge dateString={opt.slaExpire}/> </td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
     
     {tab!='processed-substituted' && <td>
      {tab=="substituted" && <JisButton variant='plain' onClick={()=>onAddService(opt,index)}>Substituted Service</JisButton>}  
      {tab=="awaitingcfo-substituted" && <JisButton variant='plain'  onClick={()=>gotoESwearing(opt,index)}>e-Swearing</JisButton>} 

      </td>} 
      
    </tr>
    )})} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>}
        </div>
      </div>

<BackLoader open={loading} />
{otherAlert.open && <JisAlert {...otherAlert} />}
  {openCase && active!=null && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
    <div>
      <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
    </div>
    </JisDialogForm> }

    {isAddService  && <JisDialogForm title={`Complete Proof of Service: ${active?.caseNumber}`} onClose={onCloseService} minWidth='80%'>
    <div>
      <div className='tab-content'>
      <div><JisCheckbox label="Show All Parties" value={showAll} onChange={(e)=> setShowAll(e)} /> </div>
        <div style={{display:'flex', flexDirection:'column'}}>
          <div style={{fontWeight:'bold'}}>SERVED ON</div>
          <div style={{flex:1, display:'flex', flexDirection:'row'}}>
              
             {caseParties?.filter((e)=> IsDefendant(e.partyTypeId) || showAll).map((opt) => (
                <div key={opt.id} className={`selected ${opt.id==selectedParty?.id?'active':''}`} onClick={()=>onSelectParty(opt)} style={{maxWidth:300}}>
                    {opt.suffix} {opt.firstName} {opt.lastName??''}<br/> 
                 <div>{Constants.getItemById(frequentData.partyTypes,opt.partyTypeId).title}</div>
                 <div>Serve Date: {serviceDetails(opt)}</div>  
                </div>
             ))} 
           

          </div>
          <div style={{flex:3, paddingLeft:16}}>
           
          {selectedParty!=null && <div style={{display:'flex'}}>
             
              <div style={{display:'flex', maxWidth:400}}> <span style={{padding:8}}> Serve Date </span> 
                <div  className="input-group">
                  <div className='input-wrapper'>
                      <DynamicIcon iname="person_3" />
                      <input placeholder='Served On' type='date' value={servedon} onChange={(e)=> setServedOn(e.target.value)}  />
                  </div>
                </div>
            </div>
            <div style={{display:'flex', maxWidth:450}}> 
              <span style={{padding:8}}>Type Of Document </span> 
            {/*   <div className={`selected ${uplinetype=='template'?'active':''}`} onClick={()=> setUplinetype('template')}>Template</div> */}
              <div  className={`selected ${uplinetype=='attest'?'active':''}`} onClick={()=> setUplinetype('attest')}>Upload Document</div></div>
            </div>}  
            {service?.isCompleted && <div>Already worked on by CFO</div>}
           { uplinetype!='template' && <div style={{display:'flex'}}>
               <div className="btn-upload">
                <input
                  type="file"
                  accept="application/pdf"
                  id={`file-upload-${0}`}
                  onChange={(e) => handleUploadChange(e)}
                />
                <label
                  htmlFor={`file-upload-${0}`}
                  title={sFile?.filename}
                >
                  {sFile?.path == null
                    ? 'Choose File'
                    : Constants.ReduceString(
                        sFile?.filename,
                        30
                      )}
                </label>
                {sFile?.path!=null && <JisButton onClick={()=> onPreview(sFile)}>Preview</JisButton>}
              </div> 
              <div>
              {service!=null && <JisButton onClick={onSaveFile}>Save File</JisButton>}   
              </div>

            </div>} 

           <div className='view-doc'>
              {doc!=null && docline!=null && template!=null && !service?.isCompleted && uplinetype=='template' &&
              <JisPrepareTemplate templatedoc={{...doc,upline:docline,template:template}} docInfo={active} 
              isLegal={true} onDone={onPrepareDone} onInstumentAppended={onInstumentAppended}  doctype="sheriff" autoFill={autoFill} />}

              { isPreview  && uplinetype!='template' && <div style={{width:'100%',minHeight:500}}>
                <PdfViewer   pdfUrl={previewPath} /></div> } 

              {doc!=null && docline!=null && template!=null && service?.isCompleted && 
             <div className='view-temp'>
              <div className="doc">
                  <h3>{docline.documentTitle}</h3>
                  <div className="paper-doc"> <div  className='htmlwrap' dangerouslySetInnerHTML={{__html: atob(docline.templateHtml)}}></div></div>
                  {/* <JisButton onClick={()=>window.print()} icon="print">Print</JisButton> */}
              </div>
            </div>
              }
              {doc!=null && docline!=null && service?.ssAttendedTo &&  uplinetype!='template' &&
             <div className='view-temp'>
              <div style={{width:'100%',minHeight:500}}>
                <PdfViewer   pdfUrl={previewPath} /></div>
            </div>
              }

            </div>

        </div>
        </div>
        
      </div>
      </div>
    </JisDialogForm> }

    </div>
  );
}

export default ServiceSherrifSubstitutted;